import { FC } from "react";
import { LoginUserItem, Payment } from "@/types";
import { useBreakpoint } from "@/utils/hooks/useBreakpoints.ts";
import dayjs from "dayjs";
import LoadingButton from "@edusogno/primitives/loading-button";
import { useDownloadInvoiceMutation } from "@/data/payments.ts";
import { downloadBase64PDF } from "@/utils/string.ts";
import AltDownloadIcon from "@/components/icons/AltDownloadIcon.tsx";
import { useTranslation } from "react-i18next";

interface InvoiceProps {
  item: Payment;
  user: LoginUserItem;
}

const InvoiceItem: FC<InvoiceProps> = ({ item, user }) => {
  const { type, data, paid_for: paidFor, amount, id, canView } = item;
  const breakpoint = useBreakpoint();
  const { t } = useTranslation();

  const isSmall = ["xs", "sm", "md"].indexOf(breakpoint) !== -1;

  const handleDownloadPdfInvoice = (dataUrl: string) => {
    const nameFile = `${user.first_name} ${user.last_name} - ${type} - ${dayjs(
      data,
    ).format("DD-MM-YYYY")}`;

    downloadBase64PDF(dataUrl, nameFile);
  };
  const { mutate, isLoading } = useDownloadInvoiceMutation(
    handleDownloadPdfInvoice,
  );

  /**
   * Shows a JSX element for the amount if the user can view is true
   * @returns returns a JSX element or undefined
   */
  const toggleInvoiceViewting = () => {
    if (canView === 1) {
      return (
        <div className="flex flex-col text-xs text-center font-semibold justify-center items-center  text-white rounded-md px-2 py-1 bg-primary">
          <p> €{amount}</p>
        </div>
      );
    }
  };

  return (
    <div className="flex flex-row w-full items-center pl-4 gap-2 lg:gap-4 pr-6 py-3 bg-white rounded-md">
      {toggleInvoiceViewting()}

      <div className={"flex flex-col flex-grow"}>
        <p className={"text-primary text-xs font-semibold"}>
          {dayjs(data)
            .format("ddd DD/MM/YYYY")
            .toUpperCase()
            .split(".")
            .join(" ")}
        </p>
        <p className="text-base text-brand font-semibold line-clamp-1">
          {paidFor}
        </p>
      </div>
      {isSmall ? (
        <LoadingButton
          variant={"ghost"}
          size={"sm"}
          disabled={isLoading}
          loading={isLoading}
          onClick={() => {
            mutate({
              idInvoice: id,
              token: user.token,
            });
          }}
          className={
            "flex flex-row items-center gap-2 px-0 w-6 h-6 min-w-6 min-h-6 group border-none"
          }
        >
          <AltDownloadIcon className={"stroke-brand-secondary w-6 h-auto"} />
        </LoadingButton>
      ) : (
        <LoadingButton
          size={"sm"}
          disabled={isLoading}
          loading={isLoading}
          onClick={() => {
            mutate({
              idInvoice: id,
              token: user.token,
            });
          }}
        >
          {t("btns.download")}
        </LoadingButton>
      )}
    </div>
  );
};

export default InvoiceItem;
